"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Modal = require("./Modal");

var _Modal2 = _interopRequireDefault(_Modal);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotLoggedInModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NotLoggedInModal, _Component);

  function NotLoggedInModal() {
    (0, _classCallCheck3.default)(this, NotLoggedInModal);
    return (0, _possibleConstructorReturn3.default)(this, (NotLoggedInModal.__proto__ || (0, _getPrototypeOf2.default)(NotLoggedInModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(NotLoggedInModal, [{
    key: "render",

    /*
    render() {
      const { handleClose } = this.props;
      const imageStyle = {
        width: '100%',
        height: 'auto'
      };
      const listStyle = {
        padding: '5%'
      };
      return (
        <Modal title='MaaApp' noBottom {...this.props}>
          <div className="row">
            <div className="maa-app-ad">
              <Link to="/maa-app">
                <div style={listStyle} >
                  <ul
                  >
                    <li>
                      Ei vaadi laiteasennuksia autoon
      </li>
                    <li>
                      Toimii iOS- ja Android-puhelimissa / tableteissa
      </li>
                    <li>
                      Ladattavissa App Storesta ja Google Playsta
      </li>
                    <li>
                      Mittaa kuormaus-, ajo- ja purkuajan
      </li>
                    <li>
                      GPS-matkanmittaus
      </li>
                    <li>
                      Tiedot tallentuvat suoraan sähköiseen siirtoasiakirjaan
      </li>
                    <li>
                      Turvallinen, ei tarvitse käyttää ajon aikana
      </li>
                  </ul>
                </div>
                <img
                  style={imageStyle}
                  src="/img/KL19_Olemme-mukana_720x120.jpg" />
               </Link>
            </div>
          </div>
        </Modal>
      );
      }
    */

    value: function render() {
      var handleClose = this.props.handleClose;


      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({ title: "", noBottom: true }, this.props),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-8 col-xs-offset-2" },
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "h4",
              null,
              " Et ole kirjautunut profiiliisi "
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/kirjaudu" },
                "Kirjaudu profiiliisi"
              ),
              " ",
              _react2.default.createElement("br", null),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/rekisteroidy" },
                "Tilaa Ammattilaisprofiili"
              ),
              " ",
              _react2.default.createElement("br", null),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "#", onClick: handleClose },
                "Jatka ilman kirjautumista tai profiilin tilausta."
              ),
              " ",
              _react2.default.createElement("br", null)
            )
          )
        )
      );
    }
  }]);
  return NotLoggedInModal;
}(_react.Component), _class.propTypes = {
  isShowingModal: _react.PropTypes.bool.isRequired,
  handleClose: _react.PropTypes.func.isRequired
}, _temp);
exports.default = NotLoggedInModal;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/modal/NotLoggedInModal.js
 ** module id = 1162
 ** module chunks = 0
 **/